import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// Inbound Webhooks
const postInboundWebhookPending = (state: AppState) => state.inboundWebhook.pending;
const postInboundWebhookTriggers = (state: AppState) => state.inboundWebhook.inboundWebhook;
const postInboundWebhookTriggersError = (state: AppState) => state.inboundWebhook.error;

export const postInboundWebhookPendingSelector = createSelector(postInboundWebhookPending, (pending) => pending);
export const postInboundWebhookSelector = createSelector(postInboundWebhookTriggers, (inboundWebhook) => inboundWebhook);
export const postInboundWebhookErrorSelector = createSelector(postInboundWebhookTriggersError, (error) => error);

// Outbound Webhooks
const postOutboundWebhookPending = (state: AppState) => state.outboundWebhook.pending;
const postOutboundWebhookTriggers = (state: AppState) => state.outboundWebhook.outboundWebhook;
const postOutboundWebhookTriggersError = (state: AppState) => state.outboundWebhook.error;

export const postOutboundWebhookPendingSelector = createSelector(postOutboundWebhookPending, (pending) => pending);
export const postOutboundWebhookSelector = createSelector(postOutboundWebhookTriggers, (outboundWebhook) => outboundWebhook);
export const postOutboundWebhookErrorSelector = createSelector(postOutboundWebhookTriggersError, (error) => error);

// Fetch outbound webhooks

const getOutboundWebhookListPending = (state: AppState) => state.outboundWebhookList.pending;
const getOutboundWebhookList = (state: AppState) => state.outboundWebhookList.outboundWebhookList;
const getOutboundWebhookListError = (state: AppState) => state.outboundWebhookList.error;

export const getOutboundWebhookListSelector = createSelector(getOutboundWebhookList, (webhookList) => webhookList);
export const getOutboundWebhookListPendingSelector = createSelector(getOutboundWebhookListPending,(pending) => pending);
export const getOutboundWebhookListErrorSelector = createSelector(getOutboundWebhookListError, (error) => error);

//Put inbound Extractor
const putInboundPending = (state: AppState) => state.putInbound.pending;
const putInboundExtractor = (state: AppState) => state.putInbound.status;
const putInboundErrorExtractor = (state: AppState) => state.putInbound.error;

export const putInboundPendingSelector = createSelector(putInboundPending, (pending) => pending);
export const putInboundSelector = createSelector(putInboundExtractor, (status) => status);
export const putInboundErrorSelector = createSelector(putInboundErrorExtractor, (error) => error);

//Put outbound Extractor
const putOutboundPending = (state: AppState) => state.putOutbound.pending;
const putOutboundExtractor = (state: AppState) => state.putOutbound.status;
const putOutboundErrorExtractor = (state: AppState) => state.putOutbound.error;

export const putOutboundPendingSelector = createSelector(putOutboundPending, (pending) => pending);
export const putOutboundSelector = createSelector(putOutboundExtractor, (status) => status);
export const putOutboundErrorSelector = createSelector(putOutboundErrorExtractor, (error) => error);

// DELETE Job Schedules

const deleteOutboundPending = (state: AppState) => state.deleteOutbound.pending;
const deleteOutbound = (state: AppState) => state.deleteOutbound.success;
const deleteOutboundError = (state: AppState) => state.deleteOutbound.error;

export const deleteOutboundSelector = createSelector(deleteOutbound, (deleteOutbound) => deleteOutbound);
export const deleteOutboundPendingSelector = createSelector(deleteOutboundPending,(pending) => pending);
export const deleteOutboundErrorSelector = createSelector(deleteOutboundError, (error) => error);